<script>
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'

    export default {
        components : {
            Datetime,
        },
        data() {
            return Object.assign({}, {
                locale: window.locale,
                url : '',
                upload_url : '',
                url_code : '',
                agree : false,
                step : 1,
                filled_step: 1,
                validating_step : '',
                sibling_count : 0,
                applying_class : '',
                priority_one : '',
                priority_two : '',
                priority_three : '',
                expected_entry_date : '',
                en_last_name : '',
                en_first_name : '',
                other_first_name : '',
                other_last_name : '',
                date_of_birth : '',
                gender : '',
                place_of_birth: '',
                religion: '',
                identity_no: '',
                post_number: '',
                phone: '',
                email: '',
                age : '',
                common_lang: '',
                nationality: '',
                baptized_date: '',
                address: '',
                previous_school: '',
                father_other_last_name : '',
                father_other_first_name : '',
                father_en_last_name : '',
                father_en_first_name : '',
                father_company : '',
                father_company_phone : '',
                father_address: '',
                father_occupation: '',
                father_phone: '',
                father_email: '',
                father_education: '',
                father_relationship: 'father',
                father_live_together: 'Y',

                mother_other_last_name : '',
                mother_other_first_name : '',
                mother_en_last_name : '',
                mother_en_first_name : '',
                mother_company_phone : '',
                mother_company : '',
                mother_address: '',
                mother_occupation: '',
                mother_phone: '',
                mother_email: '',
                mother_education: '',
                mother_relationship: 'mother',
                mother_live_together: 'Y',

                main_contact_person: 'father',
                how_to_know: '',
                alternative_session : '',
                previous_schooling_record: [],
                relative_record : [],
                other_remarks: '',
                upload_files : {},
                validation_scope : {
                    1 : 'class-info',
                    2 : 'student-info',
                },
                files : [],
                uploaded : [],
                application_no : '',
                url_code : '',
                interview_date : '',
                from : '',
                to: '',
                interviews : [],
                selected_interview: '',
            }, __FORM__);
        },
        props: {

        },
        methods: {
            to_form () {
                window.location.href = '/admission/form';
            },
            to_form_update () {
                window.location.href = '/admission/form-update';
            },
            to_index() {
                window.location.href = '/admission';
            },
            step_class(current_step) {
                if(this.step == current_step) {
                    return 'step clickable step-current';
                } else if(this.step > current_step) {
                    return 'step clickable step-past';
                }
                return 'step';
            },
            move_step(direction) {
                if(direction == 'add') {
                    this.step++;
                }

                if(direction == 'subtract') {
                    if(this.step > 1) {
                        this.step--;
                    }
                }

                window.scrollTo(0,0);
            },
            move_to_step(step) {
                if(this.step == 1 && this.step == 4) {
                    return false;
                }
            },
            addSibling()
            {
                this.sibling_count++;
            },
            getFileName(id) {
                let files = event.target.files;

                if(!this.upload_files[id]) {
                    this.$set(this.upload_files, id, []);
                }

                _.each(files, (item, key) => {
                    this.upload_files[id].push(item['name']);
                    this.files.push(item);
                })
            },
            removeUploadedFile(elm_id, field, key) {
                this.upload_files[field].splice(key, 1);
                // document.getElementById(elm_id).files[key] = null;
            },
            getInterviews() {
                let url = this.interview_url;
                let self = this;
                let formData = this.getLoginData();

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function() {
                        self.$store.commit('setRedirectNotification', response.data.msg);
                        self.$store.commit('setNotificationType', 'success');
                        self.interviews = response.data.msg;
                    });
                };

                let ajaxFailCallback = (error) => {
                    if (error.response.status == '422') {
                        let system_error = error.response.data.errors;
                        let errors = {};
                        let self = this;
                        Object.keys(system_error).forEach(function(key){
                            errors[key] = system_error[key];
                        })

                        self.$store.commit('setValidationError', errors);
                    } else {
                        self.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                    }
                };
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');

                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            },
            cloneObject(source_object) {
                return JSON.parse(JSON.stringify(source_object));
            },
            getLoginData() {
                let formData = new FormData;

                formData.append('application_no', this.application_no);
                formData.append('identity_no', this.identity_no);
                formData.append('email', this.email);

                return formData;
            },
            getInterviewFormData() {
                let formData = new FormData;

                formData.append('application_no', this.application_no);
                formData.append('identity_no', this.identity_no);
                formData.append('email', this.email);
                formData.append('selected_interview', this.selected_interview);

                return formData;
            },
            setInterviewKey(key) {
                this.selected_interview_key = key;
            },
            submit() {
                let url = this.url;
                let self = this;
                let formData = null;
                let ajaxSuccessCallback = null;
                let ajaxFailCallback = null;

                if(this.step == 1) {
                    url = this.login_url;
                    formData = this.getLoginData();

                    ajaxSuccessCallback = (response) => {
                        self.$nextTick(function() {
                            self.$store.commit('setRedirectNotification', response.data.msg);
                            self.$store.commit('setNotificationType', 'success');

                            this.getInterviews();
                            self.step++;
                        });
                    };

                    ajaxFailCallback = (error) => {
                        if (error.response.status == '422') {
                            let system_error = error.response;
                            let errors = {};
                            let self = this;

                            console.log(error.response);
                            self.validation_msg = system_error.data.msg;
                            self.not_valid = true;
                        }
                    };
                } else if (this.step == 2) {
                    this.step = 3;
                    return true;
                } else if (this.step == 3) {
                    url = this.select_interview_url;

                    formData = this.getInterviewFormData();

                    ajaxSuccessCallback = (response) => {
                        self.$nextTick(function() {
                            self.$store.commit('setRedirectNotification', response.data.msg);
                            self.$store.commit('setNotificationType', 'success');

                            self.confirmation_no = response.data.msg.confirmation_no;
                            self.step++;
                        });
                    };

                    ajaxFailCallback = (error) => {
                        if (error.response.status == '422') {
                            let system_error = error.response.data.errors;
                            let errors = {};
                            let self = this;
                            Object.keys(system_error).forEach(function(key){
                                errors[key] = system_error[key];
                            })

                            self.$store.commit('setValidationError', errors);
                        } else {
                            self.$store.commit('setError', (typeof error.response.data.msg != 'undefined' ? error.response.data.msg : 'Failure'));
                        }
                    };

                }
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');


                self.$root.ajax_post(url, formData, ajaxSuccessCallback, ajaxFailCallback, true, {headers: {'Content-Type': 'multipart/form-data' }});
            },
            removeRelative(index)
            {
                this.relative_record = [];
                this.sibling_count--;
            },
            printPdf()
            {
                window.open('/admission/pdf/' + this.url_code);
            },
        },
        watch: {
            step() {
                if(this.filled_step < this.step) {
                    this.filled_step = this.step;
                }

                //for testing only

                if(this.step == 6) {
                    setTimeout(() => { this.step = 7 }, 3000);
                }
            },

            sibling_count() {
                this.relative_record.push(
                    {
                        en_first_name: '',
                        en_last_name: '',
                        other_first_name: '',
                        other_last_name: '',
                        relationship: '',
                        school_year: '',
                        class: '',
                        remarks: '',
                    }
                );
            },
        },
        computed: {
            uploading_files() {
                let result = [];

                _.each(this.upload_files, (files, key) => {
                    _.each(files, (file) => {
                        result.push(file);
                    })
                })

                return result;
            },
            file_infos() {
                let result = {};

                _.each(this.upload_files, (files, key) => {
                    _.each(files, (file) => {
                        result[file] = key;
                    })
                })

                return result;

            },
        }
    }
</script>
<style>
    .vdatetime-popup__header {
        background : #0cafc2;
    }
    .vdatetime-popup__actions__button {
        color : #0cafc2;
    }

    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
        color: #fff;
        background: #0cafc2;
    }

    .vdatetime-year-picker__item--selected {
        color: #0cafc2;
        font-size: 32px;
    }

    .vdatetime-time-picker__item--selected {
        color: #0cafc2;
        font-size: 32px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Admission/AdmissionInterview.vue